import { Link, Typography } from '@iheartjane/reefer';

// Aeropay (JanePay) errors start with "AP" followed by 3-4 numbers
export const AEROPAY_REGEX = /Error (AP\d{3,4}): (.+)/;

export const AeropayError = ({ code = '' }: { code: string }) => {
  const formLink = (code: string) => {
    return (
      <Link
        color="error-dark"
        href={`https://customer-support.iheartjane.com/s/jane-pay-aeropay-customer-support?error=${code}`}
      >
        this form
      </Link>
    );
  };
  if (code === 'AP300') {
    return (
      <Typography as="div" color="error-dark">
        We are having issues connecting to your bank. Please select another bank
        account or payment method and fill out {formLink(code)} so we can help
        resolve this issue.
      </Typography>
    );
  }

  if (code === 'AP301') {
    return (
      <Typography as="div" color="error-dark">
        Your account has been blocked, please select another payment method and
        fill out {formLink(code)} so we can help resolve this issue.
      </Typography>
    );
  }

  if (['AP302', 'AP306', 'AP307', 'AP315'].includes(code || '')) {
    return (
      <Typography as="div" color="error-dark">
        We could not approve your payment, your available balance might be
        insufficient for this transaction. Please select another bank account or
        payment method and fill out {formLink(code)} so we can help resolve this
        issue.
      </Typography>
    );
  }

  if (code === 'AP304') {
    return (
      <Typography color="error-dark">
        Your transaction amount exceeds the daily limit on your account. Please
        try a smaller purchase or another payment method and fill out{' '}
        {formLink(code)} so we can help resolve this issue.
      </Typography>
    );
  }

  if (code === 'AP305') {
    return (
      <Typography as="div" color="error-dark">
        We've detected delinquent activity on your account, please select
        another bank account or payment method and fill out {formLink(code)} so
        we can help resolve this issue.
      </Typography>
    );
  }

  if (code === 'AP310') {
    return (
      <Typography color="error-dark">
        We're sorry, your transaction has been declined, please select another
        bank account or payment method and fill out {formLink(code)} so we can
        help resolve this issue.
      </Typography>
    );
  }

  return (
    <Typography color="error-dark">
      Something went wrong, please select another bank account or payment method
      and fill out{' '}
      <Link
        color="error-dark"
        href="https://customer-support.iheartjane.com/s/jane-pay-aeropay-customer-support"
      >
        this form
      </Link>{' '}
      so we can help resolve this issue.
    </Typography>
  );
};
